import { render, staticRenderFns } from "./ReActivateUser.vue?vue&type=template&id=c2a636f0&"
import script from "./ReActivateUser.vue?vue&type=script&lang=js&"
export * from "./ReActivateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports